const REFRESH_INTERVAL_MS = 60 * 1000

const navigationStore = useNavigationStore()
const practitionersStore = usePractitionersStore()
const organizationsStore = useOrganizationsStore()
const priorityPatientStore = usePriorityPatientsStore()
const teamsStore = useTeamsStore()
const monitorsStore = useMonitorsStore()
const devicesStore = useDevicesStore()
const observationStore = useObservationCMSStore()
const cmsStore = useCMSStore()

const PRELOAD_CONFIGURATION = [
  {
    name: 'practitioners',
    isGlobal: true,
    isRefreshed: false,
    load: async () => {
      await practitionersStore.load()
    },
  },
  {
    name: 'organizations',
    isGlobal: true,
    isRefreshed: false,
    load: async () => {
      await organizationsStore.load()
    },
  },
  {
    name: 'teams',
    isGlobal: true,
    isRefreshed: false,
    load: async () => {
      await teamsStore.load()
    },
  },
  {
    name: 'priorityPatients',
    pathNames: [],
    pathSubCategories: [],
    isRefreshed: true,
    load: async () => {
      await priorityPatientStore.load({ episodeOfCareStatuses: ['planned', 'active'], showAllPatients: true })
    },
  },
  {
    name: 'monitors',
    pathNames: [],
    pathSubCategories: [],
    isRefreshed: false,
    load: async () => {
      await monitorsStore.load()
    },
  },
  {
    name: 'devices',
    pathNames: [],
    pathSubCategories: [],
    isRefreshed: false,
    load: async () => {
      await devicesStore.load()
    },
  },
  {
    name: 'equipments',
    pathNames: [],
    pathSubCategories: [],
    isRefreshed: false,
    load: async () => {
      await devicesStore.load()
    },
  },
  {
    name: 'observation',
    isGlobal: true,
    isRefreshed: false,
    load: async () => {
      await observationStore.load()
    },
  },
  {
    name: 'cms',
    isGlobal: true,
    isRefreshed: false,
    load: async () => {
      await cmsStore.load()
    },
  },
]

export const preload = async () => {
  const route = useRoute()
  const [main, id, subCategory] = route.name?.split('-') || []
  const isEmbeded = navigationStore.embed

  for (const { isGlobal, pathNames, pathSubCategories, isRefreshed, load, name } of PRELOAD_CONFIGURATION) {
    if (isGlobal || pathNames?.includes(main)) {
      if (isGlobal || (isEmbeded ? pathSubCategories?.includes(subCategory) : true)) {
        try {
          await load()
        } catch (error) {
          console.error(`Failed loading ${name}`, error)
        }

        // if (isRefreshed)
        //   setInterval(async () => {
        //     try {
        //       await load()
        //     } catch (error) {
        //       console.error(`Failed refreshing ${name}`, error)
        //     }
        //   }, REFRESH_INTERVAL_MS)
      }
    }
  }
}
